<template>
  <div class="container">
    <common-head></common-head>
    <div class="inner">
      <div class="category-page">
        <div class="category-left">
          <div class="catep-list">
            <div class="o-item" v-for="(item, index) of categoryList.filter(o => !o.PARENTID)"
              :class="{ active: item.TYPE === formId }">
              <div class="o-ct-name" @click.self="changeTree(1, item.TYPE)">
                {{ item.NAME }}
                <template v-if="item.TYPE === formId">
                  <span class="icon iconfont icon-sanjiaoxingjiantou_xiangxia" @click.prevent="hdclick"></span>
                </template>
                <template v-else>
                  <span class="icon iconfont icon-sanjiaoxingjiantou_xiangzuo"
                    @click.self="changeTree(1, item.TYPE)"></span>
                </template>
              </div>
              <ul class="t-list">
                <li class="t-ct-name" v-for="(temp, i) of categoryList.filter(o => o.PARENTID == item.ID)"
                  :class="{ active: temp.ID === nodeId }" @click="changeTree(2, temp.ID)">
                  {{ temp.NAME }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="category-contain">
          <div class="cg-opt-head">
            <div class="cg-List">
              <div class="cg-mn-li">
                <div class="cg-mnli-box">
                  <div class="cg-mnboxList" :class="{ autoHeight: autoHeight }">
                    <ul>
                      <li v-for="(item, index) in menuList" :class="{ active: item.ID === menuId }"
                        @click="changeTree(3, item.ID)">
                        {{ item.NAME }}
                      </li>
                    </ul>
                  </div>
                  <div class="more" @click="changeMore" ref="More">
                    <template v-if="autoHeight">Less<span
                        class="icon iconfont icon-sanjiaoxingjiantou_xiangshang"></span></template>
                    <template v-else="autoHeight">More<span
                        class="icon iconfont icon-sanjiaoxingjiantou_xiangxia"></span></template>
                  </div>
                </div>
              </div>
            </div>
            <div class="cg-opt">
              <div class="cg-opt-list">
                <div class="item" v-for="item of optionList" :class="{ current_type: sort === item.Id }"
                  @click="changeSort(item.Id)">
                  {{ item.Title }}
                  <template v-if="item.Id">
                    <span v-if="item.Id == sort"
                      :class="'icon iconfont ' + (isAsc ? 'icon-shengxu' : 'icon-jiangxu')"></span>
                    <span v-else class="icon iconfont icon-jiangxu"></span>
                  </template>
                </div>
              </div>
              <div class="cg-p-them icon iconfont icon-caidanguanli" @click="changeThem"></div>
            </div>
          </div>
          <div class="cg-content">
            <div class="cg-thm-item">
              <ul class="p-list-them1" v-show="isShow === false">
                <li v-for="(item, index) of bookList">
                  <div class="img">
                    <a href="javascript:;" @click="$fun.openProductUrl(item.Id, item.ProductType)">
                      <!-- <div class="img-tag1">{{item.sourceopentype ==="01" ? '借阅' : '畅读' }}</div> -->
                      <template v-if="item.Cover">
                        <img :src="item.Cover" />
                      </template>
                      <template v-else>
                        <img src="/static/images/np-img.png" />
                      </template>
                      <!-- <span class="img-tag">{{item.ProductTypeText}}</span> -->
                    </a>
                  </div>
                  <div class="bkname">
                    <a href="javascript:;" @click="$fun.openProductUrl(item.Id, item.ProductType)">{{ item.Name ?
                      item.Name
                      : "NULL" }}</a>
                  </div>
                  <div class="author">{{ item.Author }}</div>
                  <div :class="item.IsCollect ? 'del-cart' : 'add-cart'" @click="$fun.addCollect(item)"
                    v-show="accountShow">{{ item.IsCollect
                      ? '- shelf' : '+ shelf' }}</div>
                </li>
              </ul>
              <ul class="p-list-them2" v-show="isShow === true">
                <li v-for="item of bookList">
                  <div class="img">
                    <a href="javascript:;" @click="$fun.openProductUrl(item.Id, item.ProductType)">
                      <!-- <div class="img-tag1">{{item.sourceopentype ==="01" ? '借阅' : '畅读' }}</div> -->
                      <template v-if="item.Cover">
                        <img :src="item.Cover" />
                      </template>
                      <template v-else>
                        <img src="/static/images/np-img.png" style="border: 1px solid #eee" />
                      </template>
                      <!-- <span class="img-tag2">{{item.ProductTypeText}}</span> -->
                    </a>
                  </div>
                  <div class="info">
                    <div class="bkname">
                      <a href="javascript:;" @click="$fun.openProductUrl(item.Id, item.ProductType)">{{ item.Name ?
                        item.Name : "NULL" }}</a>
                    </div>
                    <div class="author">
                      {{ item.Author ? item.Author : "NULL" }}
                    </div>
                    <div class="decr" v-if="item.Introduction">{{ $fun.delHtmlTag(item.Introduction) }}</div>
                    <div :class="item.IsCollect ? 'del-cart' : 'add-cart'" @click="$fun.addCollect(item)"
                      v-show="accountShow">{{
                        item.IsCollect ? '- shelf' : '+ shelf' }}</div>
                  </div>
                </li>
              </ul>
            </div>
            <el-empty description="NULL" v-show="bookList.length == 0"></el-empty>
            <common-page :pageNo="pageNo" :pageSize="pageSize" :pageTotal="pageTotal"
              @currentChange="changePage"></common-page>
          </div>
        </div>
      </div>
    </div>
    <common-foot></common-foot>
  </div>
</template>

<script>
import CommonHead from "common/head/Head";
import CommonFoot from "common/foot/Foot";
import CommonPage from "common/plugin/pagination";
export default {
  name: "Categry",
  components: {
    CommonHead,
    CommonFoot,
    CommonPage,
  },
  data: function () {
    return {
      formId: this.$route.query.form ? this.$route.query.form : "",
      nodeId: this.$route.query.node ? this.$route.query.node : "",
      menuId: this.$route.query.menu ? this.$route.query.menu : "",
      categoryList: [],
      menuList: [],
      bookList: [],
      optionList: [
        { Id: "", Title: 'All-round' },
        { Id: "1", Title: 'Publisher time' },
        { Id: "2", Title: 'Reading volume' },
        { Id: "3", Title: 'Online time' },
      ],
      isShow: false,
      autoHeight: false,
      isActive: 0,
      isAsc: false,
      sort: "",
      pageNo: 1,
      pageSize: 20,
      pageTotal: 0,
      accountShow: false,
    };
  },
  async mounted() {
    await this.$onWait;
    var params = {
      orgId: this.$fun.getMember().orgId,
      isCategory: true
    };
    // if(!params.orgId) {
    //   this.$fun.openError("未找到学校");
    //   return;
    // }
    this.$bti.GetColumnTypeList(params).then((res) => {
      // if (res.data.length == 0) {
      //   this.$fun.openError("未配置栏目类型");
      //   return;
      // }
      //console.log(res.data)

      this.categoryList = res.data;

      if (!this.formId) {
        this.formId = this.categoryList[0].TYPE
      }
      if (!this.nodeId) {
        this.nodeId = this.categoryList.filter(o => o.PARENTID == this.categoryList.filter(o => o.TYPE == this.formId && !o.PARENTID)[0].ID)[0].ID;
      }
      this.loadMenu();
      this.loadBook();
    });
    // this.loadType();
    //如果不是ip免登录用户
    let userid = this.jwt_decode(window.localStorage.Token).userId;
    if (userid != '13400000001') {
      this.accountShow = true;
    }
  },
  methods: {
    loadMenu: function () {
      this.menuList = [{ ID: "", NAME: "ALL", BASEID: "" }];
      this.menuList.push(...this.categoryList.filter(o => o.PARENTID == this.nodeId));
    },
    loadBook: function () {
      var params = {
        page: this.pageNo,
        rows: this.pageSize,
        sort: this.sort,
        order: this.isAsc ? "ASC" : "DESC",
        keys: "",
        word: "",
        orgId: this.$fun.getMember().orgId,
        firstIds: [this.formId].toString(),
      };
      if (this.menuId) {
        params.thirdIds = [this.categoryList.filter(o => o.ID == this.menuId)[0].BASEID].toString();
      } else {
        params.secondIds = [this.categoryList.filter(o => o.ID == this.nodeId)[0].BASEID].toString();
      }
      this.$bti.GetElkPage(params).then((res) => {
        if (res.code != 1) {
          this.bookList = [];
          return;
        }
        this.bookList = res.data.Data;
        this.pageTotal = res.data.Count > 10000 ? 10000 : res.data.Count;
      });
    },
    changeTree: function (node, id) {
      this.menuId = '';
      if (node === 1) {
        this.formId = id;
        this.nodeId = this.categoryList.filter(o => o.PARENTID == this.categoryList.filter(o => o.TYPE == this.formId && !o.PARENTID)[0].ID)[0].ID;
      } else if (node === 2) {
        this.nodeId = id;
      } else {
        this.menuId = id;
      }
      if (node !== 3) {
        this.loadMenu();
      }
      this.pageNo = 1;
      this.loadBook();
    },
    changeThem: function () {
      this.isShow = !this.isShow;
    },
    changeMore: function () {
      this.autoHeight = !this.autoHeight;
    },
    changeSort: function (id) {
      if (this.sort == id) {
        this.isAsc = !this.isAsc;
      } else {
        this.isAsc = true;
        this.sort = id;
      }
      this.loadBook();
    },
    hdclick: function () {
      this.formId = "";
    },
    changePage: function (val) {
      this.pageNo = val;
      this.loadBook();
    },
  },
};
</script>

<style lang="css" scoped>
.category-page {
  padding: 30px 0px;
  /* padding-bottom: 50px; */
  min-height: 600px;
}

.category-page:after {
  display: block;
  overflow: hidden;
  clear: both;
  height: 0;
  visibility: hidden;
  content: "";
}

.category-left {
  float: left;
  width: 230px;
  background: #fff;
}

.catep-list .o-item .o-ct-name {
  position: relative;
  height: 60px;
  line-height: 60px;
  padding: 0px 45px 0 25px;
  font-size: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: bold;
  cursor: pointer;
}

.catep-list .o-item .o-ct-name a {
  color: #252525;
}

.catep-list .o-item .o-ct-name .icon {
  display: inline-block;
  position: absolute;
  right: 25px;
  top: 0px;
  font-size: 24px;
}

.catep-list .o-item .t-list .t-ct-name {
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  padding: 0px 25px;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: pointer;
}

.catep-list .o-item .t-list {
  display: none;
}

.catep-list .o-item.active .t-list {
  display: block;
}

.catep-list .o-item.active .t-list .t-ct-name.active {
  background: #fbe3d7;
  border-left: 3px solid #ed7538;
}

.category-contain {
  float: right;
  width: 950px;
  width: calc(100% - 250px);
}

.cg-opt-head {
  background: #fff;
  margin-bottom: 20px;
  padding: 0px 30px;
}

.cg-opt-head .cg-List {
  border-bottom: 1px solid #eee;
}

.cg-opt-head .cg-List:after,
.cg-mnboxList ul:after,
.cg-opt:after,
.cg-opt-list:after {
  display: block;
  overflow: hidden;
  clear: both;
  height: 0;
  visibility: hidden;
  content: "";
}

.cg-opt-head .cg-List .cg-t-tile {
  float: left;
  width: 80px;
}

.cg-t-tile {
  height: 57px;
  line-height: 57px;
  font-size: 16px;
}

.cg-opt-head .cg-List .cg-mn-li {
  float: right;
  width: 100%;
}

.cg-mnli-box {
  position: relative;
}

.cg-mnboxList {
  position: relative;
  left: 0px;
  top: 0px;
  height: 57px;
  overflow: hidden;
}

.cg-mnboxList.autoHeight {
  height: auto;
  overflow: inherit;
}

.cg-mnboxList ul {
  padding-right: 130px;
  padding-top: 12px;
  padding-bottom: 10px;
}

.cg-mnboxList ul li {
  float: left;
  height: 35px;
  line-height: 35px;
  margin: 0px 40px 0px 0px;
  font-size: 16px;
  color: #252525;
  cursor: pointer;
}

.cg-mnboxList ul li.active {
  font-weight: bold;
}

.cg-content {
  background: #fff;
}

.cg-opt .cg-t-tile {
  float: left;
}

.cg-opt .cg-opt-list {
  float: left;
}

.cg-opt .cg-p-them {
  float: right;
  color: #666;
  width: 50px;
  height: 57px;
  line-height: 57px;
  text-align: right;
  cursor: pointer;
}

.cg-opt-list .item {
  float: left;
  height: 57px;
  line-height: 57px;
  font-size: 16px;
  padding-right: 60px;
  cursor: pointer;
}

.cg-opt-list .item.current_type {
  font-weight: bold;
}

.cg-content {
  padding: 25px 30px;
}

.p-list-them1 .img {
  position: relative;
}

.p-list-them1 .img .img-tag1 {
  position: absolute;
  top: 0;
  right: 0;
  width: 48px;
  height: 48px;
  background: linear-gradient(-135deg, #409EFF, #409EFF 50%, transparent 50%, transparent 100%);
  color: #fff;
  padding-left: 19px;
}


.p-list-them2 .img {
  position: relative;
}

.p-list-them2 .img .img-tag1 {
  position: absolute;
  top: 0;
  left: 87px;
  width: 48px;
  height: 48px;
  background: linear-gradient(-135deg, #409EFF, #409EFF 50%, transparent 50%, transparent 100%);
  color: #fff;
  padding-left: 19px;
}

.img-tag2 {
  position: absolute;
  left: 89px;
  bottom: -179px;
  background: #e98e07;
  color: #fff;
  padding: 3px 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/categry/Categry.vue